export default "__VITE_ASSET__BbAbx6WL__"